import { CreatePersonBlockMetadata } from './contracts';

export function getFieldOrder(metaData: CreatePersonBlockMetadata) {
	if (metaData.fieldOrder) return metaData.fieldOrder;

	// fallback behaviour
	return [...Object.keys(metaData.editFields ?? {}), ...Object.keys(metaData.businessFields ?? {})];
}
